import { SHIPMENT_KIND_TITLE } from '@locales/id/shipments';
import { shipmentKindInfo } from '@locales/id/labels';
import type { ShipmentKind } from '@lib/api';
import { Chip } from '@ui';

/**
 * The note's kind: "Penarikan" in its own calm violet wherever notes are listed; a distribution note stays unmarked
 * there (the usual case keeps lists calm) unless `always` (the note's own page, where the kind is a fact).
 */
export function ShipmentKindChip({ kind, always }: { kind?: ShipmentKind | null; always?: boolean }) {
  const info = shipmentKindInfo(kind);
  if (info.kind === 'DISTRIBUTION' && !always) return null;
  return (
    <Chip tone={info.tone} title={SHIPMENT_KIND_TITLE[info.kind]}>
      {info.label}
    </Chip>
  );
}
